import { currentFileBrowserActivity } from './publish.js';

export function fileBrowserRequestInFlight(): boolean {
  return currentFileBrowserActivity().inFlightRequests > 0;
}

export function getFileBrowserInFlightReadCount(): number {
  return currentFileBrowserActivity().inFlightReads;
}

export function fileBrowserReadInFlight(): boolean {
  return getFileBrowserInFlightReadCount() > 0;
}
